import { RegisterKind } from 'api/common/constants'
import Footer from 'components/Footer'
import Header from 'components/Header'
import * as React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const { type, hash } = useParams()
  const electronicUrl = `/summaryElectronic/${type}/${hash}`
  const paperUrl = `/summaryPaper/${type}/${hash}`
  React.useEffect(() => {
    if (!hash || (type !== RegisterKind.Invite && type !== RegisterKind.Assignment)) {
      navigate('/login')
    }
  })
  return (
    <>
      <Header title="概要書面交付方法の確認" />
      <main>
        <section className="mx-4 my-5">
          <div>
            <div>AUBEクエストコネクターの登録サイトです。ご登録にはAUBEクエストID、報酬受取用の金融機関の口座情報が必要になりますのでご用意ください。</div>
            <div>手続きを進めてい行きますと本人確認用に下記の証明書の撮影が必要になります。</div>
            <div>・運転免許証</div>
            <div>・マイナンバーカード</div>
            <div>・在留カード</div>
            <div>・パスポート</div>
          </div>
          <div className="note-warning mt-4">
            <div>法人契約の場合</div>
            <div>発行後3ヶ月以内の登記事項証明書（履歴事項全部証明書）の全ページの画像をご用意ください。（画像1枚につき10M未満）</div>
          </div>
          <h2 className="mt-5">概要書面交付方法の選択</h2>
          <p className="mt-4">AUBEクエストコネクタープランでは、概要書面、契約書面をお渡しするうえで、紙面による交付と電子書面による交付のいずれかを選択できます。</p>
          <div className="mt-4">
            <Button variant="primary" href={electronicUrl} className="w-100 py-4">
              電子書面を選ぶ
            </Button>
          </div>
          <div className="mt-4">
            <Button variant="danger" href={paperUrl} className="w-100 py-4">
              紙面を選ぶ
            </Button>
          </div>
          <div className="mt-5">
            <Button variant="success" href="/contactUs" className="w-100 py-4">
              お問い合わせ
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
